module.exports = __webpack_public_path__ + "static/media/preview_screen6.53573ca4.png";